import Box from '@mui/material/Box';
import Tooltip, { type TooltipProps } from '@mui/material/Tooltip';
import type { ReactElement, ReactNode } from 'react';

type ConditionalTooltipProps = {
  children: ReactElement;
  hasTooltip?: boolean;
  placement?: TooltipProps['placement'];
  title: ReactNode;
};

export const ConditionalTooltip = ({ children, hasTooltip, placement, title }: ConditionalTooltipProps) => {
  if (!hasTooltip) {
    return children;
  }

  return (
    <Tooltip placement={placement} title={title}>
      <Box>{children}</Box>
    </Tooltip>
  );
};
